module.exports = __webpack_public_path__ + "static/Hero4-03a96e1f65b2e66d5934aa416721e576.png";